export default __webpack_public_path__ + "images/MathFLAT_Attendance_src_main_res_raw_sound_exit_girl.wav";